// extracted by mini-css-extract-plugin
export default {"header":"Header_header__YDMlF","sliderMobile":"Header_sliderMobile__IVpUD","sliderWeb":"Header_sliderWeb__27BYP","imgCont":"Header_imgCont__1uGBP","circles":"Header_circles__g5upe"};